import { render, staticRenderFns } from "./add_judges.vue?vue&type=template&id=1f458226&scoped=true"
import script from "./add_judges.vue?vue&type=script&lang=js"
export * from "./add_judges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f458226",
  null
  
)

export default component.exports